import { render, staticRenderFns } from "./ReportShareDialog.vue?vue&type=template&id=00145b48"
import script from "./ReportShareDialog.vue?vue&type=script&lang=js"
export * from "./ReportShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportShareDialog.vue?vue&type=style&index=0&id=00145b48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports